import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { RxPlus } from "react-icons/rx";

import { Line, toast } from "@sorcery/ui";

import { VariantLabel } from "~/components/atoms/VariantLabel";
import { fullCollectionlistJotai } from "~/state/collectionJotai";
import type { VariantType } from "~/types/card";
import { api } from "~/utils/trpc";

export const CollectionTicker = ({ variant }: { variant: VariantType }) => {
  const trpcUtils = api.useUtils();
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const fullCollectionlist = useAtomValue(fullCollectionlistJotai)!;
  const [total, setTotal] = useState(
    fullCollectionlist
      .find((c) => c.card.id === variant.cardId)
      ?.groupings.find((g) => g.variantId === variant.id)?.items.length ?? 0,
  );

  // keep in sync with updates from elsewhere (companion decklist etc)
  useEffect(() => {
    setTotal(
      fullCollectionlist
        .find((c) => c.card.id === variant.cardId)
        ?.groupings.find((g) => g.variantId === variant.id)?.items.length ?? 0,
    );
  }, [fullCollectionlist, variant.cardId, variant.id]);

  const { mutateAsync: tickUp } = api.collection.tickUpCollectionQuantity.useMutation({
    onSuccess() {
      toast("Collection updated");
      void trpcUtils.collection.getCollectionlistBySession.invalidate();
      void trpcUtils.collection.search.invalidate();
    },
    onError() {
      toast.error("Something went wrong");
    },
  });
  return (
    <>
      <div className="mt-1 flex w-full items-center justify-between gap-2">
        {/* set/product details */}
        <div className="-mt-1.5 w-3/4 text-sm">
          <VariantLabel variant={variant} />
        </div>

        <div className="flex w-1/4 items-center justify-end">
          <div className="h-[25px] w-[20px] text-center">{total}</div>
          <div
            onClick={() => {
              setTotal(total + 1);
              void tickUp({ cardId: variant.cardId, variantId: variant.id });
            }}
            className={
              "hover:border-primary -mt-1 flex h-[25px] w-[25px] cursor-pointer select-none flex-col items-center justify-center rounded-full p-1 transition-shadow hover:border hover:shadow-[0_0_18px_rgba(255,123,0,0.9)]"
            }
          >
            <RxPlus size={25} />
          </div>
        </div>
      </div>
      <Line className="mx-2 mb-1" />
    </>
  );
};
